import type { UpdateColourPaletteMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  namedOperations,
  UpdateColourPaletteDocument,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

import type { UpdateColourPaletteInput } from '../nativeMutationInputs';
export type { UpdateColourPaletteInput } from '../nativeMutationInputs';

export const useUpdateColourPalette = createMutationHook({
  name: 'updateColourPalette',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.colourPalette.update.mutationOptions({ onSuccess }),
  mapInput: (input: UpdateColourPaletteInput) => input,
  invalidate: (trpc) => [
    trpc.frontend.colourPalette.getColourPalettes.queryKey(),
  ],
  mapResponse: (result: { Id: string }): UpdateColourPaletteMutation => ({
    update_colour_palette_by_pk: {
      __typename: 'colour_palette',
      Id: result.Id,
    },
  }),
  graphqlDocument: UpdateColourPaletteDocument,
  graphqlVariables: (input: UpdateColourPaletteInput) => ({
    Id: input.Id,
    Name: input.Name,
    Settings: input.Settings,
  }),
  refetchQueries: [namedOperations.Query.getColourPalettes],
});
